export var ADMIN_PATHS = {
    TEMPLATE_TASK: '/admin/templates/:id/tasks/:taskId',
};
